import { IStore } from "types/IStore";

export const addManifest = (store: IStore) => {
  const appBaseUrl = location.origin;

  const manifest = {
    id: `/${store.storeHash}`,
    name: store.name,
    short_name: store.name,
    start_url: `${appBaseUrl}/${store.storeHash}`,
    display: "standalone",
    background_color: "#ffffff",
    theme_color: "#000000",
    homepage_url: `${appBaseUrl}/${store.storeHash}`,
    scope: `/${store.storeHash}`,
    icons: [
      {
        src: `${appBaseUrl}/pwa/${store.storeHash}/icon-192.png`,
        sizes: "192x192",
        type: "image/png",
      },
      {
        src: `${appBaseUrl}/pwa/${store.storeHash}/icon-512.png`,
        sizes: "512x512",
        type: "image/png",
      },
    ],
  };

  const blob = new Blob([JSON.stringify(manifest)], { type: "application/json" });
  const manifestURL = URL.createObjectURL(blob);

  const link = document.createElement("link");
  link.rel = "manifest";
  link.href = manifestURL;

  // Remove anterior se existir
  const oldLink = document.querySelector('link[rel="manifest"]');
  if (oldLink) {
    document.head.removeChild(oldLink);
  }

  document.head.appendChild(link);
};
